import { createSlice } from "@reduxjs/toolkit";
import { getVersionHistory } from "../thunks/versionHistoryStateThunks";
import type { VersionHistoryActionTypes, VersionHistoryState } from "../types/versionHistoryState.types";
import { VERSION_HISTORY_SLICE_NAME } from "../utils/storeUtils";

const initialState: VersionHistoryState = {
  versionHistory: [],
  isLoading: false,
  error: undefined,
  previewData: undefined,
  backupConfiguration: undefined,
  currentConfiguration: undefined,
};

export const versionHistorySlice = createSlice({
  name: VERSION_HISTORY_SLICE_NAME,
  initialState,
  reducers: {
    setVersionHistory: (state, action: VersionHistoryActionTypes["setVersionHistory"]) => {
      state.versionHistory = action.payload;
    },
    setIsLoading: (state, action: VersionHistoryActionTypes["setIsLoading"]) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: VersionHistoryActionTypes["setError"]) => {
      state.error = action.payload;
    },
    updatePreviewConfiguration: (state, action: VersionHistoryActionTypes["updatePreviewConfiguration"]) => {
      state.previewData = action.payload;
    },
    updateBackupConfiguration: (state, action: VersionHistoryActionTypes["updateBackupConfiguration"]) => {
      state.backupConfiguration = action.payload;
    },
    updateCurrentConfiguration: (state, action: VersionHistoryActionTypes["updateCurrentConfiguration"]) => {
      state.currentConfiguration = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getVersionHistory.pending, (state) => {
      state.isLoading = true;
      state.error = undefined;
    });
    builder.addCase(getVersionHistory.fulfilled, (state, action) => {
      state.isLoading = false;
      state.versionHistory = action.payload;
      state.error = undefined;
    });
    builder.addCase(getVersionHistory.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
      state.versionHistory = [];
    });
  },
});
export default versionHistorySlice.reducer;
